import { Button, Divider, Dropdown, Menu, Select, Space } from "antd";
import React, { Component } from "react";
import "./app_quotation_card.css";
import { ReactComponent as ThreeDotsIcon } from "../../../ThreeDots.svg";
import AppCardStatus from "../app_card_status/app_card_status";
import Config from "../../../Config";
import RouteBloc from "../../../bloc/route_bloc";
import QuotationBloc from "../../../bloc/quotation_bloc";
import AppModal from "../app_modal/app_modal";
import ProposalBloc from "../../../bloc/mrtt_proposal_bloc";

class AppQuotationCard extends Component {
    constructor(props) {
        super(props);
        let routeParams = RouteBloc.extractRouteParamsFromProps(this.props.props);
        this.state = {
            client: Config.context,
            route: routeParams,
            isDeleteModalOpen: false,
        }
    }

    getDropDownItem = (id) => {
        let status = this.getQuotationStatus();
        if (this.props.module == 'quotation' && this.getQuotationStatus() == 'GENERATED'){
            // let proposalStatus = await ProposalBloc.getProposalDetail()
        }
        let dropdownitem = Config[this.props.module].actions[this.getQuotationStatus()].labels;
        let item = [];
        dropdownitem.map((data, idx) => {
            item.push(
                {
                    label: (
                        <div
                            onClick={(e) => { e.stopPropagation(); this.handleDropDownItemClick(data); }}
                            className="dropdown_item"
                        >
                            {data}
                        </div>

                    ),
                    key: idx
                }
            )
        })
        return item;
    }

    propCardData = () => {
        return this.props.data;
    } 

    propShowMenu = () => {
        return this.props.showMenu;
    }

    handleViewQuotation = () => {
        if (this.props.module == 'quotation') {
            if (this.getQuotationStatus() == 'DRAFT') {
                this.props.handleEdit(this.props.id)
            } else {
                window.location.href = `/${this.state.client}/${this.state.route.entity}/${Config.routes.generic.mrtt}/${Config.routes.generic.quotation_details}/${this.props.id}`
            }
        } else {

        }

    }

    handleDropDownItemClick(item) {
            if (item === 'View') {
                let detailsRoute = this.props.module === 'quotation' || item === 'View Quotation' ? Config.routes.generic.quotation_details : Config.routes.generic.proposal;
                return (
                    window.location.href = `/${this.state.client}/${this.state.route.entity}/${Config.routes.generic.mrtt}/${detailsRoute}/${this.props.id}`
                )
            }
            else if (item === 'Edit' || item === 'Update') {
                this.props.handleEditQuotation(this.propCardData().id);
            }
            else if (item === 'Delete') {
                this.handleDeleteModalOpen();
            }
            else if (item === 'Proceed to Proposal') {
                this.props.handleProceedProposal(this.propCardData().id);
            }
            else if (item === 'Update Quotation') {
                return (
                    window.location.href = `/${this.state.client}/${this.state.route.entity}/${Config.routes.generic.mrtt}/${Config.routes.generic.quotation_personal_details}/${this.propCardData().id}`
                )
            }
            else if (item === 'Update Proposal') {
                let proposalId = this.props.module === 'quotation'? this.propCardData().reference1: this.propCardData().id;
                this.props.handleEditProposal(this.propCardData());
            }
            else if (item === 'View Proposal') {
                return (
                    window.location.href = `/${this.state.client}/${this.state.route.entity}/${Config.routes.generic.mrtt}/${Config.routes.generic.proposal_details}/${this.propCardData().id}`
                )
            }
            else if (item === 'Delete Proposal') {

            }
            else if (item === 'View Quotation') {
                return (
                    window.location.href = `/${this.state.client}/${this.state.route.entity}/${Config.routes.generic.mrtt}/${Config.routes.generic.quotation_details}/${this.propCardData().quotationId}`
                )
            }
    }

    handleDeleteModalOpen = () => {
        this.setState({ isDeleteModalOpen: true })
    }

    handleDeleteModalClose = () => {
        this.setState({ isDeleteModalOpen: false })
    }

    getQuotationStatus() {
        let quotationStatus = ''
        this.props.status === 'Proposal Proceeded' ? quotationStatus = 'GENERATED' :
            this.props.status === 'Quotation Created' ? quotationStatus = 'PENDING' :
                this.props.status === 'Draft' ? quotationStatus = 'DRAFT' :
                    quotationStatus = this.props.status;

        return quotationStatus;
    }

    async handleDeleteQuotation(id) {
        let response = await QuotationBloc.deleteQuotationById(id);
        console.log("Delete?", response);
    }

    handleSelection() {
        return this.props.handleSelection() || ''
    }

    render() {
        return (
            <>
                <div
                    className={this.props.selected == true ? "p-3 quotation_grid_selected_container" : "p-3 quotation_grid_container"}
                    style={{ width: '32%' }}
                    onClick={() => this.props.selection == true ? this.handleSelection() : ''}
                // onClick={() => this.handleViewQuotation()}
                >
                    <div className="d-flex justify-content-between align-items-center mb-2">
                        <div className="quotation_grid_title">
                            {this.props.name}
                        </div>
                        {
                            this.propShowMenu() &&
                            <Dropdown
                                overlay={
                                    <Menu
                                        style={{
                                            marginTop: "12px",
                                            width: '200px'
                                        }}
                                        items={this.props.getDropDownItem(this.propCardData(), this.props.status)}
                                    />
                                }
                                trigger={["click"]}
                                className="header__profile"
                            >
                                <Button type="text" className="px-1" onClick={e => e.stopPropagation()}>
                                    <ThreeDotsIcon className="p-0 " />
                                </Button>
                            </Dropdown>

                        }

                    </div>
                    <AppCardStatus
                        status={
                            this.getQuotationStatus()
                        }
                        module={this.props.module}
                    />
                    <div className="mt-3">
                        <div className="row">
                            <div className="col-4" style={{ color: '#9599B6' }}>Ref No.</div>
                            <div className="col-8">{this.props.refNo}</div>
                        </div>
                        <div className="row">
                            <div className="col-4" style={{ color: '#9599B6' }}>ID No.</div>
                            <div className="col-8">{this.props.idNo}</div>
                        </div>
                        <Divider className="my-2" />
                        <div className="row">
                            <div className="col-4" style={{ color: '#9599B6' }}>Creation Date</div>
                            <div className="col-8">{this.props.createdDate}</div>
                        </div>
                        <div className="row">
                            <div className="col-4" style={{ color: '#9599B6' }}>Last Updated</div>
                            <div className="col-8">{this.props.lastUpdated}</div>
                        </div>
                    </div>
                </div>
                {/* Modal for Delete Quotation */}
                <AppModal
                    open={this.state.isDeleteModalOpen}
                    handleModalClose={this.handleDeleteModalClose}
                    width={'50%'}
                    title={'Do you want to delete this quotation ?'}
                    negativeButtonText={'Cancel'}
                    positiveButtonText={'Yes, Delete'}
                    handleNegativePress={this.handleDeleteModalClose}
                    handlePositivePress={() => this.props.handleDelete(this.props.id)}
                >
                    <span style={{ fontSize: 16, color: '#808EA8' }}>If you delete this quotation, you wil loose any progress you’ve made.</span>
                </AppModal>
            </>
        );
    }
}

export default AppQuotationCard;
